import { getEntityUrl } from '@culture/common-helpers/cultureUtils';

const wordVariants = {
	institutes: {
		single: 'Учреждение',
		some: 'Учреждения',
		many: 'Учреждений'
	},
	places: {
		single: 'Место',
		some: 'Места',
		many: 'Мест'
	},
	objects: {
		single: 'Объект',
		some: 'Объекта',
		many: 'Объектов'
	},
	concertVenues: {
		single: 'Площадка',
		some: 'Площадки',
		many: 'Площадок'
	},
	movies: {
		single: 'Фильм',
		some: 'Фильма',
		many: 'Фильмов'
	},
	performances: {
		single: 'Спектакль',
		some: 'Спектакля',
		many: 'Спектаклей'
	},
	concerts: {
		single: 'Концерт',
		some: 'Концерта',
		many: 'Концертов'
	},
	lectures: {
		single: 'Лекция',
		some: 'Лекции',
		many: 'Лекций'
	},
	broadcast: {
		single: 'Видео',
		some: 'Видео',
		many: 'Видео'
	}
};

export const visitCatalogCardsData = [
	{
		catalog: 'museums',
		title: 'Музеи',
		wordVariants: wordVariants.institutes,
		icon: 'museums',
		url: '/museums/institutes/location-russia'
	},
	{
		catalog: 'theaters',
		title: 'Театры',
		wordVariants: wordVariants.institutes,
		icon: 'play',
		url: '/theaters/institutes/location-russia'
	},
	{
		catalog: 'concertVenues',
		title: 'Музыка',
		wordVariants: wordVariants.concertVenues,
		icon: 'music',
		url: '/music/concert-venues/location-russia'
	},
	{
		catalog: 'libraries',
		title: 'Литература',
		wordVariants: wordVariants.places,
		icon: 'novel',
		url: '/literature/libraries/location-russia'
	},
	{
		catalog: 'russiaImages',
		title: 'Образы России',
		wordVariants: wordVariants.places,
		icon: 'russiaImages',
		url: '/russia/location-russia'
	},
	{
		catalog: 'zoos',
		title: 'Зоопарки',
		wordVariants: wordVariants.places,
		icon: 'zoos',
		url: '/visit/zoos'
	},
	{
		catalog: 'parks',
		title: 'Парки',
		wordVariants: wordVariants.places,
		icon: 'parks',
		url: '/visit/parks'
	},
	{
		catalog: 'circuses',
		title: 'Цирки',
		wordVariants: wordVariants.places,
		icon: 'circuses',
		url: '/visit/circuses'
	},
	{
		catalog: 'religionHeritage',
		title: 'Традиции',
		wordVariants: wordVariants.places,
		icon: 'traditions',
		url: '/traditions/religion-heritage/location-russia'
	},
	{
		catalog: 'educationalInstitutes',
		title: 'Образование',
		wordVariants: wordVariants.institutes,
		icon: 'educational',
		url: '/lectures/educational/location-russia'
	},
	{
		catalog: 'architecture',
		title: 'Архитектура',
		wordVariants: wordVariants.objects,
		icon: 'architecture',
		url: '/architecture/institutes/location-russia'
	},
	{
		catalog: 'foreignObjects',
		title: 'Зарубежное наследие',
		wordVariants: wordVariants.objects,
		icon: 'foreignObjects',
		url: '/traditions/foreign-heritage'
	}
];

export const watchCatalogCardsData = [
	{
		catalog: 'movies',
		title: 'Кино',
		wordVariants: wordVariants.movies,
		icon: 'movies',
		url: '/cinema/movies'
	},
	{
		catalog: 'performances',
		title: 'Театр',
		wordVariants: wordVariants.performances,
		icon: 'play',
		url: '/theaters/performances'
	},
	{
		catalog: 'concerts',
		title: 'Музыка',
		wordVariants: wordVariants.concerts,
		icon: 'music',
		url: '/music/concerts'
	},
	{
		catalog: 'lectures',
		title: 'Образование',
		wordVariants: wordVariants.lectures,
		icon: 'educational',
		url: '/lectures/movies'
	},
	{
		catalog: 'broadcast',
		title: 'Прямые трансляции',
		wordVariants: wordVariants.broadcast,
		icon: 'broadcast',
		url: '/live/archive'
	}
];

export const getTagList = (tags, type) =>
	tags.map((tag) => {
		let url = null;

		if (tag.entityType === 'rubrics') {
			url = `/${tag.path}`;
		} else if (tag.entityType === 'rubricPages') {
			url = `/${tag.rubric.path}`;
		} else if (
			tag.entityType === 'tags' &&
			tag.type === 'poem' &&
			type === 'read'
		) {
			url = `/literature/poems/tag-${tag.name}`;
		} else {
			url = getEntityUrl(tag.entityType, tag);
		}

		return {
			title: tag.entityType === 'rubricPages' ? tag.rubric.title : tag.title,
			url,
			name: tag.name
		};
	});
